import cn from 'classnames';

import useScreenSizeConstants from 'hooks/useScreenSizeConstants';

const DashedHorizontalLine = ({ color }) => {
  const { isLargeDesktopView } = useScreenSizeConstants();
  const length = isLargeDesktopView ? 8 : 5;

  return (
    <div className="flex items-center">
      {Array.from({ length: length }).map((_, i) => (
        <div
          key={i}
          className={cn(
            'h-[2px] rounded',
            i === 0 || i === 7 ? 'w-1 bp1:w-4' : 'w-2 bp1:w-8',
            color,
            i !== 0 && 'bp1:ml-2',
            i !== 7 && 'bp1:mr-2'
          )}
        />
      ))}
    </div>
  );
};

DashedHorizontalLine.propTypes = {
  color: PropTypes.string.isRequired,
};

export default DashedHorizontalLine;
